export enum DtwinListDisplayContext {
  DTWINS = "dtwins",
  FLEET = "fleet",
  DTWIN_DETAIL = "dtwinDetail",
}
